import { render } from "./FrenchDisciplinePanel.vue?vue&type=template&id=2592690f"
import script from "./FrenchDisciplinePanel.vue?vue&type=script&lang=js"
export * from "./FrenchDisciplinePanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__